<template>
  <div>
    <AdButton
      type="add"
      :text="$t('actor')"
      @click="open('add')"
    />

    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <v-card>
        <AdCardTitle dialog>
          {{ $t('actors') }}
        </AdCardTitle>

        <v-card-text class="mt-3">
          <EditableDropdown
            v-model="actor"
            :label="$t('actor')"
            :items="availableActorList"
            item-value="id"
            item-text="name"
            :locale="projectLanguage"
            :disabled="mode === 'edit'"
          />

          <EditableDropdown
            v-model="role"
            :label="$t('role')"
            :items="roles"
            item-value="value"
            item-text="label"
          />
        </v-card-text>

        <v-card-actions class="dialogbottomstrip">
          <v-spacer></v-spacer>
          <AdButton type="cancel" @click="close"/>
          <AdButton type="save" :disabled="!actor || !role" @click="save"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'ScenarioActorDialog',

  props: {
    actorList: {
      type: Array,
      required: false,
      default: () => []
    },
    existingActorList: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      dialog: false,
      mode: 'add',
      item: null,
      role: null,
      actor: null
    }
  },

  computed: {
    /**
     * Get available actor list.
     * @returns {[]}
     */
    availableActorList () {
      return this.actorList.filter((actor) => {
        return (this.mode === 'edit' && actor.id === this.item?.id) ||
          !this.existingActorList.find((existingActor) => existingActor.id === actor.id)
      })
    },

    projectLanguage () {
      return this.$store.getters['app/projectLanguage']
    },

    /**
     * Get actor types as available roles.
     * @returns {any}
     */
    roles () {
      return this.$store.getters['server/getActorTypes']
    }
  },

  methods: {
    /**
     * Open the dialog.
     * @param mode
     */
    open (mode) {
      // Check if mode is add.
      if (mode === 'add') {
        // Reset item.
        this.item = null
      }

      // Check if user is logged in.
      if (this.isUserLoggedIn === true) {
        // Rest actor.
        this.actor = this.item?.id || null
        // Rest role.
        this.role = this.item?.role || null

        // Set mode.
        this.mode = mode
        // Open dialog.
        this.dialog = true
      }
    },

    /**
     * Start edit mode.
     * @param item
     */
    edit (item) {
      // Set item.
      this.item = item
      // Open dialog.
      this.open('edit')
    },

    /**
     * Close the dialog.
     */
    close () {
      // Close dialog.
      this.dialog = false
    },

    /**
     * Save.
     */
    save () {
      // Close dialog.
      this.close()
      // Emit change event.
      this.$emit('change', {
        mode: this.mode,
        options: {
          id: this.actor,
          role: this.role
        }
      })
    }
  }
}
</script>
